import { ICreditorInfo, IDebtorInfo } from '@common/interfaces/entityInfo'
import { combineReducers } from 'redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.ADD_DEBTOR_REQUEST:
      case actions.ADD_CREDITOR_REQUEST:
      case actions.LIST_CREDITORS_REQUEST:
      case actions.LIST_DEBTORS_REQUEST:
        return [...state, action.type]
      case actions.ADD_CREDITOR_SUCCESS:
      case actions.ADD_CREDITOR_FAILURE:
      case actions.ADD_DEBTOR_SUCCESS:
      case actions.ADD_DEBTOR_FAILURE:
      case actions.LIST_CREDITORS_SUCCESS:
      case actions.LIST_CREDITORS_FAILURE:
      case actions.LIST_DEBTORS_SUCCESS:
      case actions.LIST_DEBTORS_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  creditors(state: ICreditorInfo[] = [], action: IAction): ICreditorInfo[] {
    switch (action.type) {
      case actions.LIST_CREDITORS_SUCCESS:
        return action.data as ICreditorInfo[]
      default:
        return state
    }
  },
  debtors(state: IDebtorInfo[] = [], action: IAction): IDebtorInfo[] {
    switch (action.type) {
      case actions.LIST_DEBTORS_SUCCESS:
        return action.data as IDebtorInfo[]
      default:
        return state
    }
  },
})
